import { Skeleton, Button, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination, Autoplay } from "swiper";
import { useRematch } from "../../utils/useRematch";
import { RootState, RootDispatch } from "../../model";

import "swiper/swiper.less";
import "./index.less";

SwiperCore.use([EffectCoverflow, Pagination, Autoplay]);

const mapState = (state: RootState) => ({
  ...state.main,
  ...state.rolePlus,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.rolePlus,
});

export default function Gallery() {
  const [
    { userInfo, RolePlusTokenList, RolePlusContract, loading },
    { getRolePlusURI, changeImageUrl },
  ] = useRematch(mapState, mapDispatch);

  useEffect(() => {
    if (RolePlusContract) {
      getRolePlusURI();
    }
  }, [RolePlusContract, userInfo]);

  const [newImageUrl, setNewImageUrl] = useState("");
  const [curIndex, setCurIndex] = useState(0);
  const [showChangeInput, setShowChangeInput] = useState(false);

  return (
    <div className="index-swiper-container" id="gallery">
      <Swiper
        effect="coverflow"
        grabCursor
        centeredSlides
        preloadImages
        onAfterInit={() => {
          console.log("load!");
        }}
        updateOnImagesReady
        tabIndex={curIndex}
        coverflowEffect={{
          rotate: 20,
          stretch: 0,
          depth: 350,
          modifier: 1,
          slideShadows: false,
        }}
        initialSlide={3}
        slidesPerView="auto"
        // loop
        onSlideChange={(e) => {
          setCurIndex(e.realIndex);
        }}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {RolePlusTokenList &&
          RolePlusTokenList.map((token, index) => {
            const base64 = token.URI.image.split(
              "data:image/svg+xml;base64,"
            )[1];
            const svgCode = window.atob(base64);
            return (
              <SwiperSlide key={index}>
                <div className="roleplus-img">
                  {svgCode ? (
                    <div
                      style={{ width: "100%" }}
                      id={`base64-rolePlus-${index}`}
                      dangerouslySetInnerHTML={{ __html: svgCode }}
                    ></div>
                  ) : (
                    <Skeleton variant="rectangular" width={210} height={118} />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>
      {RolePlusTokenList && RolePlusTokenList.length > 0 ? (
        <Button
          variant="contained"
          style={{ marginTop: "60px" }}
          onClick={() => {
            setShowChangeInput(true);
          }}
        >
          Change Background Image for #
          {RolePlusTokenList && RolePlusTokenList[curIndex]?.id}
        </Button>
      ) : (
        <p
          style={{
            fontSize: "48px",
            fontWeight: 600,
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          }}
        >
          There is no Role+ in the wallet address.
        </p>
      )}
      {showChangeInput && (
        <div
          style={{
            margin: "0 auto",
            width: "50%",
            maxWidth: "500px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextField
            style={{ marginTop: "60px" }}
            id="standard-basic"
            label="New Background Image Url"
            variant="standard"
            value={newImageUrl}
            onChange={(e) => {
              setNewImageUrl(e.target.value);
            }}
          />
          <Button
            variant="contained"
            style={{ marginTop: "60px" }}
            disabled={
              RolePlusTokenList?.length === 0 ||
              !RolePlusTokenList ||
              loading.effects.rolePlus.changeImageUrl
            }
            onClick={() => {
              let element = document.getElementById(
                `base64-rolePlus-${curIndex}`
              );
              const imageNode: any =
                element?.childNodes[0].childNodes[1].childNodes[0]
                  .childNodes[2];
              imageNode.setAttribute("xlink:href", newImageUrl);
              if (RolePlusTokenList && RolePlusTokenList.length > 0) {
                changeImageUrl({
                  tokenId: RolePlusTokenList[curIndex]?.id,
                  imageUrl: newImageUrl,
                });
              }
            }}
          >
            Submmit
          </Button>
        </div>
      )}
    </div>
  );
}
